export default {
    controller: 'uploadContractsController',
    template: require('../views/uploadContracts.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/uploadContracts.component.js